const LAZY_VIDEO_SELECTOR = 'video[data-ch-lazy-video]';
const SOURCE_SELECTOR = 'source[data-ch-lazy-src]';
const LOAD_ROOT_MARGIN = '0px';
const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function needsAppleVideoSource() {
  const ua = window.navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  const isSafari = /^((?!chrome|android|crios|fxios|edg|edgios|opr|opera).)*safari/i.test(ua);

  return isIOS || isSafari;
}

function canPlaySource(video, source) {
  if (!(source instanceof HTMLSourceElement)) return false;

  const type = source.getAttribute('type');
  return !type || video.canPlayType(type) !== '';
}

function loadVideo(video) {
  if (!(video instanceof HTMLVideoElement) || video.dataset.chLazyVideoLoaded === 'true') return;
  if (reducedMotionQuery.matches) return;

  const sources = Array.from(video.querySelectorAll(SOURCE_SELECTOR));
  const preferredSourceType = needsAppleVideoSource() ? 'apple' : 'webm';
  const fallbackSourceType = preferredSourceType === 'apple' ? 'webm' : 'apple';
  const playableSource =
    sources.find((source) => source.dataset.chVideoSource === preferredSourceType && canPlaySource(video, source)) ??
    sources.find((source) => source.dataset.chVideoSource === fallbackSourceType && canPlaySource(video, source)) ??
    sources.find((source) => canPlaySource(video, source)) ??
    sources[0];

  if (!(playableSource instanceof HTMLSourceElement)) return;

  const src = playableSource.getAttribute('data-ch-lazy-src');
  if (!src) return;

  playableSource.setAttribute('src', src);
  playableSource.removeAttribute('data-ch-lazy-src');

  video.dataset.chLazyVideoLoaded = 'true';
  video.load();

  if (video.hasAttribute('autoplay')) {
    video.play().catch(() => {});
  }
}

function loadVideoWhenPageSettles(video) {
  if (!(video instanceof HTMLVideoElement)) return;

  const run = () => {
    const requestIdleCallback = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 250));
    requestIdleCallback(() => loadVideo(video), { timeout: 2500 });
  };

  if (document.readyState === 'complete') {
    run();
    return;
  }

  window.addEventListener('load', run, { once: true });
}

function observeVideo(video) {
  if (!(video instanceof HTMLVideoElement)) return;

  if (!('IntersectionObserver' in window)) {
    if (video.dataset.chVideoLoad === 'idle') {
      loadVideoWhenPageSettles(video);
    } else {
      loadVideo(video);
    }
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        observer.unobserve(video);
        if (video.dataset.chVideoLoad === 'idle') {
          loadVideoWhenPageSettles(video);
        } else {
          loadVideo(video);
        }
      });
    },
    { rootMargin: LOAD_ROOT_MARGIN }
  );

  observer.observe(video);
}

document.querySelectorAll(LAZY_VIDEO_SELECTOR).forEach(observeVideo);

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;

  event.target.querySelectorAll(LAZY_VIDEO_SELECTOR).forEach(observeVideo);
});
